module.exports = __webpack_public_path__ + "e00a22b4cbc833a23cc37bc9c0d3b312.png";